import { useFormik } from 'formik';
import * as Yup from 'yup';
import { SystemLogoColorfulIcon } from 'static/icons';
import { Button, Input } from 'components';
import * as S from './styles';

export function ResetPasswordPage() {
  const initialValues = {
    email: '',
  };

  const Validation = Yup.object().shape({
    email: Yup.string()
      .required('E-mail obrigatório')
      .email('Digite um e-mail válido'),
  });

  const formResetPassword = useFormik({
    initialValues,
    validationSchema: Validation,
    onSubmit: (values) => alert(values),
  });

  return (
    <S.Container>
      <S.Background />

      <S.Content>
        <SystemLogoColorfulIcon />

        <form onSubmit={formResetPassword.handleSubmit}>
          <Input
            type="email"
            name="email"
            label="E-mail"
            placeholder="usuário@domínio.com"
            onChange={formResetPassword.handleChange}
            value={formResetPassword.values.email}
            errorMessage={formResetPassword.errors.email}
          />

          <Button type="submit">Verificar</Button>
        </form>
      </S.Content>
    </S.Container>
  );
}
